"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MEDIA_QUERIES = void 0;
var mobile = "(max-width: 576px)";
var tablet = "(max-width: 768px)";
var laptop = "(min-width: 769px) and (max-width: 1023px)";
var desktop = "(min-width: 1024px)";
exports.MEDIA_QUERIES = {
    mobile: mobile,
    tablet: tablet,
    laptop: laptop,
    desktop: desktop,
};
